import { render, staticRenderFns } from "./importConfigXML.vue?vue&type=template&id=2d837ab4&"
import script from "./importConfigXML.vue.ts?vue&type=script&lang=ts&"
export * from "./importConfigXML.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports